import {connect} from 'react-redux';
import {List} from 'immutable';
import moment from 'moment';
import Config from '../../../../../Config';

import {
  loadPlannerToDoSuggested,
  updatePlannerToDoSuggested,
  createPlannerToDoSuggested,
  deletePlannerToDoSuggested,
  plannerToDoSuggestedFormDestroy
} from '../../../../../state/modules/plannerToDosSuggested/actions';
import PlannerToDoSuggestedForm from '../components/PlannerToDoSuggestedForm';

const inputs = List([
  'title',
  'description',
  'module',
  'status',
  'overdue_date_at',
]);

const mapStateToProps = (state, ownProps) => {

  const data = {}, errors = {};
  for (const val of inputs.values()) {
    data[val] = state.entities.getIn(['plannerToDosSuggested', ownProps.id, val], '');
    if (state.plannerToDosSuggested.getIn(['form', 'errors', val])) {
      errors[val] = state.plannerToDosSuggested.getIn(['form', 'errors', val]);
    }
  }

  // change select number values to strings to work with ant design select inputs
  Object.keys(data).forEach(x => {
    if (['status'].includes(x)) {
      data[x] = data[x].toString();
    }
  });

  data['overdue_date_at'] = data['overdue_date_at']
    ? moment(data['overdue_date_at'], Config.get('API_DATETIME_FORMAT'))
    : null;

  return {
    isLoading: state.plannerToDosSuggested.get('isLoading'),
    isSubmitting: state.plannerToDosSuggested.getIn(['form', 'isSubmitting']),
    success: state.plannerToDosSuggested.getIn(['form', 'success']),
    created_id: state.plannerToDosSuggested.getIn(['form', 'created_id']),
    data: data,
    errors: errors,
    createdAt: state.entities.getIn(['plannerToDosSuggested', ownProps.id, 'created_at'], null),
    updatedAt: state.entities.getIn(['plannerToDosSuggested', ownProps.id, 'updated_at'], null),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    load: (id, cb) => {
      dispatch(loadPlannerToDoSuggested(id, cb));
    },
    update: (id, data, cb) => {
      dispatch(updatePlannerToDoSuggested(id, data, cb));
    },
    create: (data, cb) => {
      dispatch(createPlannerToDoSuggested(data, cb));
    },
    delete: (id, cb) => {
      dispatch(deletePlannerToDoSuggested(id, cb))
    },
    destroyForm: (formState) => {
      dispatch(plannerToDoSuggestedFormDestroy(formState));
    }
  }
}

const PlannerToDoSuggestedFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PlannerToDoSuggestedForm);

export default PlannerToDoSuggestedFormContainer;